module.exports = "/_next/static/media/f09ec257e141f37009e8ae3cee785c05.svg";